import { styled } from "../../../../styles";

export const AppointmentsContainer = styled("div", {
  width: "100%",
  minHeight: "220px",
  height: "100%",

  display: "flex",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  flexWrap: "wrap",

  backgroundColor: "$white",
  fontSize: "14px",
  fontWeight: "500",
  color: "#666666",

  marginTop: "6px",

  th: {
    zIndex: 1,
  },
});

export const TagContainer = styled("div", {
  width: "100%",
  display: "flex",
  justifyContent: "center",

  div: {
    position: "initial",
    width: "129px",
    justifyContent: "center",
    fontSize: "12px",
  },
});

// Empty state mirrors the patient messages empty state (illustration + caption).
// `bordered` adds its own border for the standalone /appointments page; inside
// the patient page the surrounding panel already provides the border.
export const EmptyStateImageContainer = styled("div", {
  width: "100%",
  minHeight: "300px",

  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  rowGap: "10px",

  borderRadius: "8px",
  backgroundColor: "$white",
  boxSizing: "border-box",

  variants: {
    bordered: {
      true: {
        border: "1px solid #ECECEC",
      },
    },
  },
});

export const NoAppointmentsMessage = styled("p", {
  marginTop: "10px",
  width: "418px",

  textAlign: "center",

  fontFamily: "$openSans",
  fontWeight: 400,
  fontSize: "16px",
  lineHeight: "21px",

  color: "$charcoal",
});

export const DeleteAppointmentButton = styled("div", {
  width: "28px",
  height: "28px",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  visibility: "hidden",

  borderRadius: "$round",

  "&:hover": {
    backgroundColor: "rgba(217, 217, 217, 0.4)",
  },
});
